import React from "react";
import Meta from "../components/Meta";
import Header from "../components/Navigation/Header";
import Footer from "../components/Home/Footer";
import Contact from "../components/Home/Contact";
import Hero from "../components/Home/Hero";
import Value from "../components/Home/Value";
import Services from "../components/Home/Services";

function IndexPage(props) {
  return (
    <>
      <Meta title="Sound Commerce | A full-suite global payments consultancy." />
      <div className="animated-gradient dark">
        <div className="body-solid-background">
          <Header />
          <Hero />
          <Services />
          <Value />
          <Contact />
          <Footer />
        </div>
      </div>
    </>
  );
}

export default IndexPage;
